(function () {
    'use strict';
    /* jshint -W071, -W074 */

    angular
        .module('blocks.smart')
        .filter('smartSubObjectFilter', smartSubObjectFilter);

    /* @ngInject */
    function smartSubObjectFilter() {
        // allows us to have a select filter on smart tables.
        // Usage:
        //  <smart-select collection="vm.someCollection"></smart-select>
        // Creates:
        //  <smart-select collection="vm.someCollection">
        //  <select><select>
        //  </smart-select>
        return function (value, path) {
            var segs = path.split('/');
            var root = value;

            while (segs.length > 0) {
                var pathStep = segs.shift();
                if (typeof root[pathStep] === 'undefined') {
                    root[pathStep] = segs.length === 0 ? { value: '' } : {};
                }
                root = root[pathStep];
            }
            return root;

        };

    }
})();

